import { render } from "./PlayersCountBox.vue?vue&type=template&id=5e1fc1b0"
import script from "./PlayersCountBox.vue?vue&type=script&lang=js"
export * from "./PlayersCountBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__